/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCompany = /* GraphQL */ `
  query GetCompany($id: ID!) {
    getCompany(id: $id) {
      id
      name
      premier
      email
      website
      phone
      phoneExt
      alertMessage
      IPCorp
      active
      updatedAt
      createdAt
      owner
      accounts {
        items {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      hq {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const listCompanys = /* GraphQL */ `
  query ListCompanys(
    $filter: ModelCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      nextToken
    }
  }
`;
export const searchCompanys = /* GraphQL */ `
  query SearchCompanys(
    $filter: SearchableCompanyFilterInput
    $sort: SearchableCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      nextToken
      total
    }
  }
`;
export const listAccounts = /* GraphQL */ `
  query ListAccounts(
    $filter: ModelAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getAccount = /* GraphQL */ `
  query GetAccount($id: ID!) {
    getAccount(id: $id) {
      id
      name
      nameLegal
      namePrevious
      status
      premier
      createdAt
      ownershipType
      processorId
      approvalDate
      underwritingStatus
      nameDba
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alert
      IPCorp
      addressMailing
      bankAccount
      addressPhysical
      accountCompanyId
      owner
      updatedAt
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      persons {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchAccounts = /* GraphQL */ `
  query SearchAccounts(
    $filter: SearchableAccountFilterInput
    $sort: SearchableAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const listServices = /* GraphQL */ `
  query ListServices(
    $filter: ModelServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getService = /* GraphQL */ `
  query GetService($id: ID!) {
    getService(id: $id) {
      id
      name
      nameLegal
      description
      pilot
      merchantNumber
      email
      website
      phone
      phoneExt
      status
      processorId
      approvalDate
      underwritingStatus
      IPCorp
      serviceType
      bankAccount
      addressPhysical
      addressMailing
      createdAt
      updatedAt
      isRestructured
      nameDba
      processor
      proposalStatementValue
      phoneBusiness
      phoneSupport
      phoneFax
      ein
      alertMessage
      ownershipType
      avgTrxAmount
      totalCashCreditSalesMonthly
      estAvgMcVisaTicketSaleAmount
      volumeMcVisaOutletMonthly
      dateUwResult
      dateContractExt
      uwResult
      dateOpen
      dateClosed
      businessType
      busSicCode
      busSicCodeDesc
      busProductsSold
      busSalesLimitM
      busTicketAvg
      busTicketMax
      busSwipePct
      busKeyPct
      busWebPct
      busMailPct
      busAgeY
      busAgeM
      busBusToBus
      busBusToCon
      busLocationCnt
      busSeasonOn
      busSeasonM
      busSeasonOpenM
      busSeasonCloseM
      amex
      amexNum
      discover
      discoverNum
      wexVoyagerOn
      wexVoyagerId
      esaId
      ebtFnsNum
      ebtCashOn
      checkServiceVendor
      checkServiceNum
      giftVendor
      giftVendorNum
      debitPinOn
      cashCreditSalesM
      mcVisaSaleAvg
      mcVisaVolM
      checksCntAvgM
      owner
      closeRequested
      closeDate
      closeReason
      closeReasonDetails
      closeEtfAmountRes
      closeCancelFee
      closeResReportDate
      closeEtfAmount
      closeEtfAdjust
      closeEtfRefundAmount
      closeEtfRefundDate
      closeEtfChargedDate
      closeEtfWaiveReason
      closeEtfWaiveOther
      closeResReportRefundDate
      beta
      pendingResponsibility
      dateSubmitted
      dateFirstProcessing
      declineReason
      declineNotes
      annualAmount
      annualAmountPCI
      altMonthMinAmount
      isWithdrawalAccount
      wbankName
      wbankRouting
      wbankAccount
      withdrawalAccount
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      portfolios {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      serviceProduct {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      closeEtfWaiveAppover {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const searchServices = /* GraphQL */ `
  query SearchServices(
    $filter: SearchableServiceFilterInput
    $sort: SearchableServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const listPortfolios = /* GraphQL */ `
  query ListPortfolios(
    $filter: ModelPortfolioFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPortfolios(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getPortfolio = /* GraphQL */ `
  query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
      id
      name
      description
      premier
      status
      owner
      createdAt
      updatedAt
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      reportPortfolios {
        items {
          id
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchPortfolios = /* GraphQL */ `
  query SearchPortfolios(
    $filter: SearchablePortfolioFilterInput
    $sort: SearchablePortfolioSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPortfolios(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getPortfolioService = /* GraphQL */ `
  query GetPortfolioService($id: ID!) {
    getPortfolioService(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const listPortfolioServices = /* GraphQL */ `
  query ListPortfolioServices(
    $filter: ModelPortfolioServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPortfolioServices(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        portfolio {
          id
          name
          description
          premier
          status
          owner
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchPortfolioServices = /* GraphQL */ `
  query SearchPortfolioServices(
    $filter: SearchablePortfolioServiceFilterInput
    $sort: SearchablePortfolioServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPortfolioServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        portfolio {
          id
          name
          description
          premier
          status
          owner
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const getReportPortfolios = /* GraphQL */ `
  query GetReportPortfolios($id: ID!) {
    getReportPortfolios(id: $id) {
      id
      createdAt
      updatedAt
      owner
      portfolio {
        id
        name
        description
        premier
        status
        owner
        createdAt
        updatedAt
        services {
          nextToken
        }
        reportPortfolios {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listReportPortfolioss = /* GraphQL */ `
  query ListReportPortfolioss(
    $filter: ModelReportPortfoliosFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReportPortfolioss(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        owner
        portfolio {
          id
          name
          description
          premier
          status
          owner
          createdAt
          updatedAt
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchReportPortfolioss = /* GraphQL */ `
  query SearchReportPortfolioss(
    $filter: SearchableReportPortfoliosFilterInput
    $sort: SearchableReportPortfoliosSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchReportPortfolioss(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        owner
        portfolio {
          id
          name
          description
          premier
          status
          owner
          createdAt
          updatedAt
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const listProducts = /* GraphQL */ `
  query ListProducts(
    $filter: ModelProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getProduct = /* GraphQL */ `
  query GetProduct($id: ID!) {
    getProduct(id: $id) {
      id
      name
      description
      status
      billingMethod
      serial
      platform
      appType
      connect
      conversion
      encryptionKey
      purchaseSwap
      feeMonthly
      cashDiscount
      owner
      virtualTerminal
      accountVault
      recurring
      customerSignUp
      authNetEmulator
      multMerchantMultiDeposit
      multiMerchantNumber
      notesComments
      setupFee
      perItemFee
      feeMonthlyAmount
      terminalOrTsysId
      midV
      storeNumber
      url
      usernames
      gatewayId
      vendorContactNotes
      conversionSetupCost
      soldAmount
      warrantyReplacement
      replacementDate
      isPinPad
      pinPadPurchaseAmount
      FPPPinMonthlyFee
      pabx
      staticIp
      dns1
      gatewayIp
      subnet
      dns2
      secureFileCheck
      securityLevel
      tipLine
      counterTip
      serverNumer
      autoCloseTime
      giftCardProvider
      ebt
      avs
      checkProviderNumber
      fraud
      merchantNumber
      purchaseCard
      taxId
      downloadPhone
      portNumber
      deviceId
      emvSmartCard
      nfc
      autoClose
      giftCards
      internalPinPad
      checkServices
      cvv2
      multiMerchant
      invoiceNumber
      customerCode
      createdAt
      updatedAt
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      billToService {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      productOption {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchProducts = /* GraphQL */ `
  query SearchProducts(
    $filter: SearchableProductFilterInput
    $sort: SearchableProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getProductChild = /* GraphQL */ `
  query GetProductChild($id: ID!) {
    getProductChild(id: $id) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const listProductChilds = /* GraphQL */ `
  query ListProductChilds(
    $filter: ModelProductChildFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductChilds(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        parent {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        child {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchProductChilds = /* GraphQL */ `
  query SearchProductChilds(
    $filter: SearchableProductChildFilterInput
    $sort: SearchableProductChildSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductChilds(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        parent {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        child {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const getProductService = /* GraphQL */ `
  query GetProductService($id: ID!) {
    getProductService(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const listProductServices = /* GraphQL */ `
  query ListProductServices(
    $filter: ModelProductServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchProductServices = /* GraphQL */ `
  query SearchProductServices(
    $filter: SearchableProductServiceFilterInput
    $sort: SearchableProductServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const listProductOptions = /* GraphQL */ `
  query ListProductOptions(
    $filter: ModelProductOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getProductOption = /* GraphQL */ `
  query GetProductOption($id: ID!) {
    getProductOption(id: $id) {
      id
      name
      category
      brand
      legacyName
      status
      notes
      owner
      createdAt
      updatedAt
      products {
        items {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        nextToken
      }
      children {
        items {
          id
          parentId
          required
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchProductOptions = /* GraphQL */ `
  query SearchProductOptions(
    $filter: SearchableProductOptionFilterInput
    $sort: SearchableProductOptionSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductOptions(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getProductOptionChild = /* GraphQL */ `
  query GetProductOptionChild($id: ID!) {
    getProductOptionChild(id: $id) {
      id
      parentId
      required
      owner
      createdAt
      updatedAt
      esData
      esSync
      parent {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      child {
        id
        name
        category
        brand
        legacyName
        status
        notes
        owner
        createdAt
        updatedAt
        products {
          nextToken
        }
        children {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
    }
  }
`;
export const listProductOptionChilds = /* GraphQL */ `
  query ListProductOptionChilds(
    $filter: ModelProductOptionChildFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProductOptionChilds(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        parent {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        child {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchProductOptionChilds = /* GraphQL */ `
  query SearchProductOptionChilds(
    $filter: SearchableProductOptionChildFilterInput
    $sort: SearchableProductOptionChildSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchProductOptionChilds(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        parentId
        required
        owner
        createdAt
        updatedAt
        esData
        esSync
        parent {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        child {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const listPersons = /* GraphQL */ `
  query ListPersons(
    $filter: ModelPersonFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersons(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getPerson = /* GraphQL */ `
  query GetPerson($id: ID!) {
    getPerson(id: $id) {
      id
      given_name
      middle_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number_verified
      phone_mobile
      phone_number
      phone_other
      phone_home
      fax_number
      addressHome
      addressOther
      ssn
      dob
      dl_number
      createdAt
      updatedAt
      description
      premier
      cognito_userid
      owner
      companys {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      accounts {
        items {
          id
          role
          title
          email
          business_email
          other_email
          ownership
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
    }
  }
`;
export const searchPersons = /* GraphQL */ `
  query SearchPersons(
    $filter: SearchablePersonFilterInput
    $sort: SearchablePersonSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPersons(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const listSalesReps = /* GraphQL */ `
  query ListSalesReps(
    $filter: ModelSalesRepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesReps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getSalesRep = /* GraphQL */ `
  query GetSalesRep($id: ID!) {
    getSalesRep(id: $id) {
      id
      given_name
      family_name
      nickname
      website
      email
      email_verified
      zoneinfo
      locale
      phone_number
      phone_number_verified
      addressMailing
      description
      premier
      cognito_userid
      createdAt
      updatedAt
      owner
      cases {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchSalesReps = /* GraphQL */ `
  query SearchSalesReps(
    $filter: SearchableSalesRepFilterInput
    $sort: SearchableSalesRepSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchSalesReps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getPersonCompany = /* GraphQL */ `
  query GetPersonCompany($id: ID!) {
    getPersonCompany(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const listPersonCompanys = /* GraphQL */ `
  query ListPersonCompanys(
    $filter: ModelPersonCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchPersonCompanys = /* GraphQL */ `
  query SearchPersonCompanys(
    $filter: SearchablePersonCompanyFilterInput
    $sort: SearchablePersonCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPersonCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getPersonAccount = /* GraphQL */ `
  query GetPersonAccount($id: ID!) {
    getPersonAccount(id: $id) {
      id
      role
      title
      email
      business_email
      other_email
      ownership
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
    }
  }
`;
export const listPersonAccounts = /* GraphQL */ `
  query ListPersonAccounts(
    $filter: ModelPersonAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPersonAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        title
        email
        business_email
        other_email
        ownership
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchPersonAccounts = /* GraphQL */ `
  query SearchPersonAccounts(
    $filter: SearchablePersonAccountFilterInput
    $sort: SearchablePersonAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchPersonAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        title
        email
        business_email
        other_email
        ownership
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseAccount = /* GraphQL */ `
  query GetCaseAccount($id: ID!) {
    getCaseAccount(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseAccounts = /* GraphQL */ `
  query ListCaseAccounts(
    $filter: ModelCaseAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseAccounts = /* GraphQL */ `
  query SearchCaseAccounts(
    $filter: SearchableCaseAccountFilterInput
    $sort: SearchableCaseAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseService = /* GraphQL */ `
  query GetCaseService($id: ID!) {
    getCaseService(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseServices = /* GraphQL */ `
  query ListCaseServices(
    $filter: ModelCaseServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseServices = /* GraphQL */ `
  query SearchCaseServices(
    $filter: SearchableCaseServiceFilterInput
    $sort: SearchableCaseServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseProduct = /* GraphQL */ `
  query GetCaseProduct($id: ID!) {
    getCaseProduct(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseProducts = /* GraphQL */ `
  query ListCaseProducts(
    $filter: ModelCaseProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseProducts = /* GraphQL */ `
  query SearchCaseProducts(
    $filter: SearchableCaseProductFilterInput
    $sort: SearchableCaseProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseCompany = /* GraphQL */ `
  query GetCaseCompany($id: ID!) {
    getCaseCompany(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseCompanys = /* GraphQL */ `
  query ListCaseCompanys(
    $filter: ModelCaseCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseCompanys = /* GraphQL */ `
  query SearchCaseCompanys(
    $filter: SearchableCaseCompanyFilterInput
    $sort: SearchableCaseCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseSalesRep = /* GraphQL */ `
  query GetCaseSalesRep($id: ID!) {
    getCaseSalesRep(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseSalesReps = /* GraphQL */ `
  query ListCaseSalesReps(
    $filter: ModelCaseSalesRepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseSalesReps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseSalesReps = /* GraphQL */ `
  query SearchCaseSalesReps(
    $filter: SearchableCaseSalesRepFilterInput
    $sort: SearchableCaseSalesRepSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseSalesReps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskAccount = /* GraphQL */ `
  query GetTaskAccount($id: ID!) {
    getTaskAccount(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskAccounts = /* GraphQL */ `
  query ListTaskAccounts(
    $filter: ModelTaskAccountFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskAccounts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskAccounts = /* GraphQL */ `
  query SearchTaskAccounts(
    $filter: SearchableTaskAccountFilterInput
    $sort: SearchableTaskAccountSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskAccounts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskService = /* GraphQL */ `
  query GetTaskService($id: ID!) {
    getTaskService(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskServices = /* GraphQL */ `
  query ListTaskServices(
    $filter: ModelTaskServiceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskServices = /* GraphQL */ `
  query SearchTaskServices(
    $filter: SearchableTaskServiceFilterInput
    $sort: SearchableTaskServiceSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskServices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskProduct = /* GraphQL */ `
  query GetTaskProduct($id: ID!) {
    getTaskProduct(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      product {
        id
        name
        description
        status
        billingMethod
        serial
        platform
        appType
        connect
        conversion
        encryptionKey
        purchaseSwap
        feeMonthly
        cashDiscount
        owner
        virtualTerminal
        accountVault
        recurring
        customerSignUp
        authNetEmulator
        multMerchantMultiDeposit
        multiMerchantNumber
        notesComments
        setupFee
        perItemFee
        feeMonthlyAmount
        terminalOrTsysId
        midV
        storeNumber
        url
        usernames
        gatewayId
        vendorContactNotes
        conversionSetupCost
        soldAmount
        warrantyReplacement
        replacementDate
        isPinPad
        pinPadPurchaseAmount
        FPPPinMonthlyFee
        pabx
        staticIp
        dns1
        gatewayIp
        subnet
        dns2
        secureFileCheck
        securityLevel
        tipLine
        counterTip
        serverNumer
        autoCloseTime
        giftCardProvider
        ebt
        avs
        checkProviderNumber
        fraud
        merchantNumber
        purchaseCard
        taxId
        downloadPhone
        portNumber
        deviceId
        emvSmartCard
        nfc
        autoClose
        giftCards
        internalPinPad
        checkServices
        cvv2
        multiMerchant
        invoiceNumber
        customerCode
        createdAt
        updatedAt
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        billToService {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        children {
          nextToken
        }
        services {
          nextToken
        }
        productOption {
          id
          name
          category
          brand
          legacyName
          status
          notes
          owner
          createdAt
          updatedAt
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskProducts = /* GraphQL */ `
  query ListTaskProducts(
    $filter: ModelTaskProductFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskProducts = /* GraphQL */ `
  query SearchTaskProducts(
    $filter: SearchableTaskProductFilterInput
    $sort: SearchableTaskProductSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskProducts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        product {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskCompany = /* GraphQL */ `
  query GetTaskCompany($id: ID!) {
    getTaskCompany(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      company {
        id
        name
        premier
        email
        website
        phone
        phoneExt
        alertMessage
        IPCorp
        active
        updatedAt
        createdAt
        owner
        accounts {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        hq {
          id
          name
          createdAt
          updatedAt
          owner
          IPCorp
          active
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskCompanys = /* GraphQL */ `
  query ListTaskCompanys(
    $filter: ModelTaskCompanyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskCompanys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskCompanys = /* GraphQL */ `
  query SearchTaskCompanys(
    $filter: SearchableTaskCompanyFilterInput
    $sort: SearchableTaskCompanySortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskCompanys(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskSalesRep = /* GraphQL */ `
  query GetTaskSalesRep($id: ID!) {
    getTaskSalesRep(id: $id) {
      id
      owner
      createdAt
      updatedAt
      esData
      esSync
      salesrep {
        id
        given_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number
        phone_number_verified
        addressMailing
        description
        premier
        cognito_userid
        createdAt
        updatedAt
        owner
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskSalesReps = /* GraphQL */ `
  query ListTaskSalesReps(
    $filter: ModelTaskSalesRepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskSalesReps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskSalesReps = /* GraphQL */ `
  query SearchTaskSalesReps(
    $filter: SearchableTaskSalesRepFilterInput
    $sort: SearchableTaskSalesRepSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskSalesReps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        esData
        esSync
        salesrep {
          id
          given_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number
          phone_number_verified
          addressMailing
          description
          premier
          cognito_userid
          createdAt
          updatedAt
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const listCases = /* GraphQL */ `
  query ListCases(
    $filter: ModelCaseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCases(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCase = /* GraphQL */ `
  query GetCase($id: ID!) {
    getCase(id: $id) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      alertMessage
      dateDue
      closedDate
      priority
      quickNote
      createdAt
      updatedAt
      owner
      rushReason
      isSystemCreated
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      template {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      caseLinks {
        items {
          id
          reason
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const searchCases = /* GraphQL */ `
  query SearchCases(
    $filter: SearchableCaseFilterInput
    $sort: SearchableCaseSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCases(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const listAttachments = /* GraphQL */ `
  query ListAttachments(
    $filter: ModelAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttachments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getAttachment = /* GraphQL */ `
  query GetAttachment($id: ID!) {
    getAttachment(id: $id) {
      id
      name
      type
      description
      s3Path
      isDeleted
      internal
      owner
      createdAt
      updatedAt
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchAttachments = /* GraphQL */ `
  query SearchAttachments(
    $filter: SearchableAttachmentFilterInput
    $sort: SearchableAttachmentSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAttachments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getRelation = /* GraphQL */ `
  query GetRelation($id: ID!) {
    getRelation(id: $id) {
      id
      fromModelType
      toModelType
      createdAt
      updatedAt
      esData
      esSync
      account {
        id
        name
        nameLegal
        namePrevious
        status
        premier
        createdAt
        ownershipType
        processorId
        approvalDate
        underwritingStatus
        nameDba
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alert
        IPCorp
        addressMailing
        bankAccount
        addressPhysical
        accountCompanyId
        owner
        updatedAt
        company {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        persons {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      attachment {
        id
        name
        type
        description
        s3Path
        isDeleted
        internal
        owner
        createdAt
        updatedAt
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      comment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listRelations = /* GraphQL */ `
  query ListRelations(
    $filter: ModelRelationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRelations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fromModelType
        toModelType
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        attachment {
          id
          name
          type
          description
          s3Path
          isDeleted
          internal
          owner
          createdAt
          updatedAt
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        comment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      nextToken
    }
  }
`;
export const searchRelations = /* GraphQL */ `
  query SearchRelations(
    $filter: SearchableRelationFilterInput
    $sort: SearchableRelationSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchRelations(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fromModelType
        toModelType
        createdAt
        updatedAt
        esData
        esSync
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        attachment {
          id
          name
          type
          description
          s3Path
          isDeleted
          internal
          owner
          createdAt
          updatedAt
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        comment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      nextToken
      total
    }
  }
`;
export const listCaseTemplates = /* GraphQL */ `
  query ListCaseTemplates(
    $filter: ModelCaseTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getCaseTemplate = /* GraphQL */ `
  query GetCaseTemplate($id: ID!) {
    getCaseTemplate(id: $id) {
      id
      name
      subject
      status
      internal
      isCompleteInOrder
      origin
      type
      dateDue
      priority
      createdAt
      updatedAt
      owner
      hasWorkflow
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
    }
  }
`;
export const searchCaseTemplates = /* GraphQL */ `
  query SearchCaseTemplates(
    $filter: SearchableCaseTemplateFilterInput
    $sort: SearchableCaseTemplateSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseTemplates(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseTemplateTask = /* GraphQL */ `
  query GetCaseTemplateTask($id: ID!) {
    getCaseTemplateTask(id: $id) {
      id
      order
      type
      dateDue
      subject
      internal
      createdAt
      updatedAt
      owner
      priority
      status
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listCaseTemplateTasks = /* GraphQL */ `
  query ListCaseTemplateTasks(
    $filter: ModelCaseTemplateTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseTemplateTasks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        type
        dateDue
        subject
        internal
        createdAt
        updatedAt
        owner
        priority
        status
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchCaseTemplateTasks = /* GraphQL */ `
  query SearchCaseTemplateTasks(
    $filter: SearchableCaseTemplateTaskFilterInput
    $sort: SearchableCaseTemplateTaskSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseTemplateTasks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        order
        type
        dateDue
        subject
        internal
        createdAt
        updatedAt
        owner
        priority
        status
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseLink = /* GraphQL */ `
  query GetCaseLink($id: ID!) {
    getCaseLink(id: $id) {
      id
      reason
      owner
      createdAt
      updatedAt
      esData
      esSync
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      linkCase {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
    }
  }
`;
export const listCaseLinks = /* GraphQL */ `
  query ListCaseLinks(
    $filter: ModelCaseLinkFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseLinks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        reason
        owner
        createdAt
        updatedAt
        esData
        esSync
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        linkCase {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
    }
  }
`;
export const searchCaseLinks = /* GraphQL */ `
  query SearchCaseLinks(
    $filter: SearchableCaseLinkFilterInput
    $sort: SearchableCaseLinkSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseLinks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        reason
        owner
        createdAt
        updatedAt
        esData
        esSync
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        linkCase {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
      }
      nextToken
      total
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      email
      given_name
      family_name
      middle_name
      nickname
      picture
      gender
      birthdate
      zoneinfo
      phone_number
      address
      source
      IPCorp
      internal
      TaskSaveAsTemplate
      CaseSaveAsTemplate
      createdAt
      updatedAt
      cogUsername
      cogUserAttributes {
        Name
        Value
      }
      cogUserCreateDate
      cogUserLastModifiedDate
      cogEnabled
      cogUserStatus
      cogEmailVerified
      cogMFAOptions {
        DeliveryMedium
        AttributeName
      }
      cogPreferredMfaSetting
      cogUserMFASettingList
      owner
      services {
        items {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        nextToken
      }
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      teams {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      tasks {
        items {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        nextToken
      }
      messages {
        items {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      caseDrafts {
        items {
          id
          subject
          from
          to
          cc
          bcc
          body
          messageCaseId
          internal
          owner
          draftType
          replyToMessageId
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      notes {
        items {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
        nextToken
      }
      changes {
        items {
          id
          owner
          createdAt
          updatedAt
          action
          modelId
          modelName
          change
        }
        nextToken
      }
      alerts {
        items {
          id
          owner
          createdAt
          updatedAt
          type
          subject
          body
          link
          ttl
          level
          status
        }
        nextToken
      }
    }
  }
`;
export const searchUsers = /* GraphQL */ `
  query SearchUsers(
    $filter: SearchableUserFilterInput
    $sort: SearchableUserSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const listHQs = /* GraphQL */ `
  query ListHQs($filter: ModelHQFilterInput, $limit: Int, $nextToken: String) {
    listHQs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getHq = /* GraphQL */ `
  query GetHq($id: ID!) {
    getHQ(id: $id) {
      id
      name
      createdAt
      updatedAt
      owner
      IPCorp
      active
      companies {
        items {
          id
          name
          premier
          email
          website
          phone
          phoneExt
          alertMessage
          IPCorp
          active
          updatedAt
          createdAt
          owner
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const searchHQs = /* GraphQL */ `
  query SearchHQs(
    $filter: SearchableHQFilterInput
    $sort: SearchableHQSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchHQs(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
        IPCorp
        active
        companies {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getSalesOffice = /* GraphQL */ `
  query GetSalesOffice($id: ID!) {
    getSalesOffice(id: $id) {
      id
      name
      active
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listSalesOffices = /* GraphQL */ `
  query ListSalesOffices(
    $filter: ModelSalesOfficeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSalesOffices(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        active
        owner
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchSalesOffices = /* GraphQL */ `
  query SearchSalesOffices(
    $filter: SearchableSalesOfficeFilterInput
    $sort: SearchableSalesOfficeSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchSalesOffices(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        active
        owner
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const listTeams = /* GraphQL */ `
  query ListTeams(
    $filter: ModelTeamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getTeam = /* GraphQL */ `
  query GetTeam($id: ID!) {
    getTeam(id: $id) {
      id
      name
      cognito_groupid
      owner
      createdAt
      default
      updatedAt
      cases {
        items {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        nextToken
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      users {
        items {
          id
          role
          cognito_userid
          cognito_groupid
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
    }
  }
`;
export const searchTeams = /* GraphQL */ `
  query SearchTeams(
    $filter: SearchableTeamFilterInput
    $sort: SearchableTeamSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTeams(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getTeamUser = /* GraphQL */ `
  query GetTeamUser($id: ID!) {
    getTeamUser(id: $id) {
      id
      role
      cognito_userid
      cognito_groupid
      owner
      createdAt
      updatedAt
      esData
      esSync
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      team {
        id
        name
        cognito_groupid
        owner
        createdAt
        default
        updatedAt
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        users {
          nextToken
        }
      }
    }
  }
`;
export const listTeamUsers = /* GraphQL */ `
  query ListTeamUsers(
    $filter: ModelTeamUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTeamUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        role
        cognito_userid
        cognito_groupid
        owner
        createdAt
        updatedAt
        esData
        esSync
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
      }
      nextToken
    }
  }
`;
export const searchTeamUsers = /* GraphQL */ `
  query SearchTeamUsers(
    $filter: SearchableTeamUserFilterInput
    $sort: SearchableTeamUserSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTeamUsers(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        role
        cognito_userid
        cognito_groupid
        owner
        createdAt
        updatedAt
        esData
        esSync
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
      }
      nextToken
      total
    }
  }
`;
export const listTasks = /* GraphQL */ `
  query ListTasks(
    $filter: ModelTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getTask = /* GraphQL */ `
  query GetTask($id: ID!) {
    getTask(id: $id) {
      id
      isTemplate
      isAvailable
      isCompleteInOrder
      type
      dateDue
      subject
      internal
      owner
      group
      order
      createdAt
      updatedAt
      priority
      status
      dateCompleted
      quickNote
      isSystemCreated
      hasWorkflow
      skipAlert
      accounts {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      services {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      products {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      companies {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      salesreps {
        items {
          id
          owner
          createdAt
          updatedAt
          esData
          esSync
        }
        nextToken
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      caseTemplate {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        dateDue
        priority
        createdAt
        updatedAt
        owner
        hasWorkflow
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      taskTemplate {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      steps {
        items {
          id
          title
          description
          isAvailable
          order
          status
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const searchTasks = /* GraphQL */ `
  query SearchTasks(
    $filter: SearchableTaskFilterInput
    $sort: SearchableTaskSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTasks(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getTaskStep = /* GraphQL */ `
  query GetTaskStep($id: ID!) {
    getTaskStep(id: $id) {
      id
      title
      description
      isAvailable
      order
      status
      owner
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listTaskSteps = /* GraphQL */ `
  query ListTaskSteps(
    $filter: ModelTaskStepFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaskSteps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        description
        isAvailable
        order
        status
        owner
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
    }
  }
`;
export const searchTaskSteps = /* GraphQL */ `
  query SearchTaskSteps(
    $filter: SearchableTaskStepFilterInput
    $sort: SearchableTaskStepSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchTaskSteps(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        description
        isAvailable
        order
        status
        owner
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
      }
      nextToken
      total
    }
  }
`;
export const listMessages = /* GraphQL */ `
  query ListMessages(
    $filter: ModelMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getMessage = /* GraphQL */ `
  query GetMessage($id: ID!) {
    getMessage(id: $id) {
      id
      sesMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      messageCaseId
      replyToMessageId
      outgoingFlag
      attachmentOptions
      messageAttachmentId
      bounces
      origin
      createdAt
      updatedAt
      owner
      person {
        id
        given_name
        middle_name
        family_name
        nickname
        website
        email
        email_verified
        zoneinfo
        locale
        phone_number_verified
        phone_mobile
        phone_number
        phone_other
        phone_home
        fax_number
        addressHome
        addressOther
        ssn
        dob
        dl_number
        createdAt
        updatedAt
        description
        premier
        cognito_userid
        owner
        companys {
          nextToken
        }
        accounts {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        messages {
          nextToken
        }
      }
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const searchMessages = /* GraphQL */ `
  query SearchMessages(
    $filter: SearchableMessageFilterInput
    $sort: SearchableMessageSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchMessages(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getCaseDraft = /* GraphQL */ `
  query GetCaseDraft($id: ID!) {
    getCaseDraft(id: $id) {
      id
      subject
      from
      to
      cc
      bcc
      body
      messageCaseId
      internal
      owner
      draftType
      replyToMessageId
      createdAt
      updatedAt
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listCaseDrafts = /* GraphQL */ `
  query ListCaseDrafts(
    $filter: ModelCaseDraftFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCaseDrafts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subject
        from
        to
        cc
        bcc
        body
        messageCaseId
        internal
        owner
        draftType
        replyToMessageId
        createdAt
        updatedAt
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchCaseDrafts = /* GraphQL */ `
  query SearchCaseDrafts(
    $filter: SearchableCaseDraftFilterInput
    $sort: SearchableCaseDraftSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchCaseDrafts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subject
        from
        to
        cc
        bcc
        body
        messageCaseId
        internal
        owner
        draftType
        replyToMessageId
        createdAt
        updatedAt
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getMessageOutgoing = /* GraphQL */ `
  query GetMessageOutgoing($id: ID!) {
    getMessageOutgoing(id: $id) {
      id
      replyToMessageId
      subject
      from
      to
      cc
      bcc
      body
      internal
      attachmentOptions
      messageCaseId
      messageUserId
      outgoingFlag
      messageAttachmentId
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listMessageOutgoings = /* GraphQL */ `
  query ListMessageOutgoings(
    $filter: ModelMessageOutgoingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageOutgoings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        replyToMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        attachmentOptions
        messageCaseId
        messageUserId
        outgoingFlag
        messageAttachmentId
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getMessageAttachment = /* GraphQL */ `
  query GetMessageAttachment($id: ID!) {
    getMessageAttachment(id: $id) {
      id
      messageId
      attachmentId
      internal
      createdAt
      updatedAt
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listMessageAttachments = /* GraphQL */ `
  query ListMessageAttachments(
    $filter: ModelMessageAttachmentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMessageAttachments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        messageId
        attachmentId
        internal
        createdAt
        updatedAt
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const getComment = /* GraphQL */ `
  query GetComment($id: ID!) {
    getComment(id: $id) {
      id
      comment
      internal
      createdAt
      updatedAt
      owner
      atMentions
      service {
        id
        name
        nameLegal
        description
        pilot
        merchantNumber
        email
        website
        phone
        phoneExt
        status
        processorId
        approvalDate
        underwritingStatus
        IPCorp
        serviceType
        bankAccount
        addressPhysical
        addressMailing
        createdAt
        updatedAt
        isRestructured
        nameDba
        processor
        proposalStatementValue
        phoneBusiness
        phoneSupport
        phoneFax
        ein
        alertMessage
        ownershipType
        avgTrxAmount
        totalCashCreditSalesMonthly
        estAvgMcVisaTicketSaleAmount
        volumeMcVisaOutletMonthly
        dateUwResult
        dateContractExt
        uwResult
        dateOpen
        dateClosed
        businessType
        busSicCode
        busSicCodeDesc
        busProductsSold
        busSalesLimitM
        busTicketAvg
        busTicketMax
        busSwipePct
        busKeyPct
        busWebPct
        busMailPct
        busAgeY
        busAgeM
        busBusToBus
        busBusToCon
        busLocationCnt
        busSeasonOn
        busSeasonM
        busSeasonOpenM
        busSeasonCloseM
        amex
        amexNum
        discover
        discoverNum
        wexVoyagerOn
        wexVoyagerId
        esaId
        ebtFnsNum
        ebtCashOn
        checkServiceVendor
        checkServiceNum
        giftVendor
        giftVendorNum
        debitPinOn
        cashCreditSalesM
        mcVisaSaleAvg
        mcVisaVolM
        checksCntAvgM
        owner
        closeRequested
        closeDate
        closeReason
        closeReasonDetails
        closeEtfAmountRes
        closeCancelFee
        closeResReportDate
        closeEtfAmount
        closeEtfAdjust
        closeEtfRefundAmount
        closeEtfRefundDate
        closeEtfChargedDate
        closeEtfWaiveReason
        closeEtfWaiveOther
        closeResReportRefundDate
        beta
        pendingResponsibility
        dateSubmitted
        dateFirstProcessing
        declineReason
        declineNotes
        annualAmount
        annualAmountPCI
        altMonthMinAmount
        isWithdrawalAccount
        wbankName
        wbankRouting
        wbankAccount
        withdrawalAccount
        account {
          id
          name
          nameLegal
          namePrevious
          status
          premier
          createdAt
          ownershipType
          processorId
          approvalDate
          underwritingStatus
          nameDba
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alert
          IPCorp
          addressMailing
          bankAccount
          addressPhysical
          accountCompanyId
          owner
          updatedAt
        }
        portfolios {
          nextToken
        }
        serviceProduct {
          id
          name
          description
          status
          billingMethod
          serial
          platform
          appType
          connect
          conversion
          encryptionKey
          purchaseSwap
          feeMonthly
          cashDiscount
          owner
          virtualTerminal
          accountVault
          recurring
          customerSignUp
          authNetEmulator
          multMerchantMultiDeposit
          multiMerchantNumber
          notesComments
          setupFee
          perItemFee
          feeMonthlyAmount
          terminalOrTsysId
          midV
          storeNumber
          url
          usernames
          gatewayId
          vendorContactNotes
          conversionSetupCost
          soldAmount
          warrantyReplacement
          replacementDate
          isPinPad
          pinPadPurchaseAmount
          FPPPinMonthlyFee
          pabx
          staticIp
          dns1
          gatewayIp
          subnet
          dns2
          secureFileCheck
          securityLevel
          tipLine
          counterTip
          serverNumer
          autoCloseTime
          giftCardProvider
          ebt
          avs
          checkProviderNumber
          fraud
          merchantNumber
          purchaseCard
          taxId
          downloadPhone
          portNumber
          deviceId
          emvSmartCard
          nfc
          autoClose
          giftCards
          internalPinPad
          checkServices
          cvv2
          multiMerchant
          invoiceNumber
          customerCode
          createdAt
          updatedAt
        }
        products {
          nextToken
        }
        cases {
          nextToken
        }
        tasks {
          nextToken
        }
        closeEtfWaiveAppover {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      task {
        id
        isTemplate
        isAvailable
        isCompleteInOrder
        type
        dateDue
        subject
        internal
        owner
        group
        order
        createdAt
        updatedAt
        priority
        status
        dateCompleted
        quickNote
        isSystemCreated
        hasWorkflow
        skipAlert
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        caseTemplate {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        taskTemplate {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        steps {
          nextToken
        }
        comments {
          nextToken
        }
      }
      message {
        id
        sesMessageId
        subject
        from
        to
        cc
        bcc
        body
        internal
        messageCaseId
        replyToMessageId
        outgoingFlag
        attachmentOptions
        messageAttachmentId
        bounces
        origin
        createdAt
        updatedAt
        owner
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      parentComment {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
      note {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
    }
  }
`;
export const listComments = /* GraphQL */ `
  query ListComments(
    $filter: ModelCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      nextToken
    }
  }
`;
export const searchComments = /* GraphQL */ `
  query SearchComments(
    $filter: SearchableCommentFilterInput
    $sort: SearchableCommentSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchComments(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        comment
        internal
        createdAt
        updatedAt
        owner
        atMentions
        service {
          id
          name
          nameLegal
          description
          pilot
          merchantNumber
          email
          website
          phone
          phoneExt
          status
          processorId
          approvalDate
          underwritingStatus
          IPCorp
          serviceType
          bankAccount
          addressPhysical
          addressMailing
          createdAt
          updatedAt
          isRestructured
          nameDba
          processor
          proposalStatementValue
          phoneBusiness
          phoneSupport
          phoneFax
          ein
          alertMessage
          ownershipType
          avgTrxAmount
          totalCashCreditSalesMonthly
          estAvgMcVisaTicketSaleAmount
          volumeMcVisaOutletMonthly
          dateUwResult
          dateContractExt
          uwResult
          dateOpen
          dateClosed
          businessType
          busSicCode
          busSicCodeDesc
          busProductsSold
          busSalesLimitM
          busTicketAvg
          busTicketMax
          busSwipePct
          busKeyPct
          busWebPct
          busMailPct
          busAgeY
          busAgeM
          busBusToBus
          busBusToCon
          busLocationCnt
          busSeasonOn
          busSeasonM
          busSeasonOpenM
          busSeasonCloseM
          amex
          amexNum
          discover
          discoverNum
          wexVoyagerOn
          wexVoyagerId
          esaId
          ebtFnsNum
          ebtCashOn
          checkServiceVendor
          checkServiceNum
          giftVendor
          giftVendorNum
          debitPinOn
          cashCreditSalesM
          mcVisaSaleAvg
          mcVisaVolM
          checksCntAvgM
          owner
          closeRequested
          closeDate
          closeReason
          closeReasonDetails
          closeEtfAmountRes
          closeCancelFee
          closeResReportDate
          closeEtfAmount
          closeEtfAdjust
          closeEtfRefundAmount
          closeEtfRefundDate
          closeEtfChargedDate
          closeEtfWaiveReason
          closeEtfWaiveOther
          closeResReportRefundDate
          beta
          pendingResponsibility
          dateSubmitted
          dateFirstProcessing
          declineReason
          declineNotes
          annualAmount
          annualAmountPCI
          altMonthMinAmount
          isWithdrawalAccount
          wbankName
          wbankRouting
          wbankAccount
          withdrawalAccount
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        task {
          id
          isTemplate
          isAvailable
          isCompleteInOrder
          type
          dateDue
          subject
          internal
          owner
          group
          order
          createdAt
          updatedAt
          priority
          status
          dateCompleted
          quickNote
          isSystemCreated
          hasWorkflow
          skipAlert
        }
        message {
          id
          sesMessageId
          subject
          from
          to
          cc
          bcc
          body
          internal
          messageCaseId
          replyToMessageId
          outgoingFlag
          attachmentOptions
          messageAttachmentId
          bounces
          origin
          createdAt
          updatedAt
          owner
        }
        parentComment {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        comments {
          nextToken
        }
        note {
          id
          note
          internal
          owner
          createdAt
          updatedAt
          atMentions
        }
      }
      nextToken
      total
    }
  }
`;
export const listNotes = /* GraphQL */ `
  query ListNotes(
    $filter: ModelNoteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getNote = /* GraphQL */ `
  query GetNote($id: ID!) {
    getNote(id: $id) {
      id
      note
      internal
      owner
      createdAt
      updatedAt
      atMentions
      case {
        id
        name
        subject
        status
        internal
        isCompleteInOrder
        origin
        type
        alertMessage
        dateDue
        closedDate
        priority
        quickNote
        createdAt
        updatedAt
        owner
        rushReason
        isSystemCreated
        person {
          id
          given_name
          middle_name
          family_name
          nickname
          website
          email
          email_verified
          zoneinfo
          locale
          phone_number_verified
          phone_mobile
          phone_number
          phone_other
          phone_home
          fax_number
          addressHome
          addressOther
          ssn
          dob
          dl_number
          createdAt
          updatedAt
          description
          premier
          cognito_userid
          owner
        }
        accounts {
          nextToken
        }
        services {
          nextToken
        }
        products {
          nextToken
        }
        companies {
          nextToken
        }
        salesreps {
          nextToken
        }
        template {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          dateDue
          priority
          createdAt
          updatedAt
          owner
          hasWorkflow
        }
        caseLinks {
          nextToken
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        team {
          id
          name
          cognito_groupid
          owner
          createdAt
          default
          updatedAt
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        notes {
          nextToken
        }
      }
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      comments {
        items {
          id
          comment
          internal
          createdAt
          updatedAt
          owner
          atMentions
        }
        nextToken
      }
    }
  }
`;
export const searchNotes = /* GraphQL */ `
  query SearchNotes(
    $filter: SearchableNoteFilterInput
    $sort: SearchableNoteSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchNotes(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        note
        internal
        owner
        createdAt
        updatedAt
        atMentions
        case {
          id
          name
          subject
          status
          internal
          isCompleteInOrder
          origin
          type
          alertMessage
          dateDue
          closedDate
          priority
          quickNote
          createdAt
          updatedAt
          owner
          rushReason
          isSystemCreated
        }
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        comments {
          nextToken
        }
      }
      nextToken
      total
    }
  }
`;
export const getChange = /* GraphQL */ `
  query GetChange($id: ID!) {
    getChange(id: $id) {
      id
      owner
      createdAt
      updatedAt
      action
      modelId
      modelName
      change
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listChanges = /* GraphQL */ `
  query ListChanges(
    $filter: ModelChangeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChanges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        action
        modelId
        modelName
        change
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchChanges = /* GraphQL */ `
  query SearchChanges(
    $filter: SearchableChangeFilterInput
    $sort: SearchableChangeSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchChanges(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        action
        modelId
        modelName
        change
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
export const getAlert = /* GraphQL */ `
  query GetAlert($id: ID!) {
    getAlert(id: $id) {
      id
      owner
      createdAt
      updatedAt
      type
      subject
      body
      link
      ttl
      level
      status
      user {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
      updatedBy {
        id
        email
        given_name
        family_name
        middle_name
        nickname
        picture
        gender
        birthdate
        zoneinfo
        phone_number
        address
        source
        IPCorp
        internal
        TaskSaveAsTemplate
        CaseSaveAsTemplate
        createdAt
        updatedAt
        cogUsername
        cogUserAttributes {
          Name
          Value
        }
        cogUserCreateDate
        cogUserLastModifiedDate
        cogEnabled
        cogUserStatus
        cogEmailVerified
        cogMFAOptions {
          DeliveryMedium
          AttributeName
        }
        cogPreferredMfaSetting
        cogUserMFASettingList
        owner
        services {
          nextToken
        }
        cases {
          nextToken
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        teams {
          nextToken
        }
        tasks {
          nextToken
        }
        messages {
          nextToken
        }
        caseDrafts {
          nextToken
        }
        comments {
          nextToken
        }
        notes {
          nextToken
        }
        changes {
          nextToken
        }
        alerts {
          nextToken
        }
      }
    }
  }
`;
export const listAlerts = /* GraphQL */ `
  query ListAlerts(
    $filter: ModelAlertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        owner
        createdAt
        updatedAt
        type
        subject
        body
        link
        ttl
        level
        status
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
    }
  }
`;
export const searchAlerts = /* GraphQL */ `
  query SearchAlerts(
    $filter: SearchableAlertFilterInput
    $sort: SearchableAlertSortInput
    $limit: Int
    $nextToken: String
  ) {
    searchAlerts(
      filter: $filter
      sort: $sort
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        owner
        createdAt
        updatedAt
        type
        subject
        body
        link
        ttl
        level
        status
        user {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
        updatedBy {
          id
          email
          given_name
          family_name
          middle_name
          nickname
          picture
          gender
          birthdate
          zoneinfo
          phone_number
          address
          source
          IPCorp
          internal
          TaskSaveAsTemplate
          CaseSaveAsTemplate
          createdAt
          updatedAt
          cogUsername
          cogUserCreateDate
          cogUserLastModifiedDate
          cogEnabled
          cogUserStatus
          cogEmailVerified
          cogPreferredMfaSetting
          cogUserMFASettingList
          owner
        }
      }
      nextToken
      total
    }
  }
`;
